import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { CMI_DIGEST } from 'components/Settings/constants';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 20px;
  border-radius: 8px;
  background-color: var(--background-gray-light);
  font-size: 14px;
  color: var(--text-secondary);
`;

const SettingsLink = styled(Link)`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--dark-blue);
  white-space: nowrap;
`;

const EnableDigestPrompt = () => (
  <Container data-test-id="cmi-digest-enable-prompt">
    Turn on your CMI Personal Digest to see weekly competitive highlights here.
    <SettingsLink to={CMI_DIGEST.url}>Go to CMI Digest Settings</SettingsLink>
  </Container>
);

export default EnableDigestPrompt;
